var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCardActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_cardActivate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_cardActivate"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5217925,11.6646669 C10.075339,12.1111229 9.35387019,12.1111229 8.90741671,11.6646669 L6.04904292,8.80734867 C5.60294659,8.36089269 5.60294659,7.63941983 6.04904292,7.19296385 C6.4954964,6.74650788 7.21910821,6.74650788 7.66449021,7.19296385 L9.68245996,9.23951805 L14.6220213,4.33457411 C15.0684748,3.8884753 15.7899436,3.8884753 16.2363971,4.33457411 C16.6828506,4.78103009 16.6828506,5.50464593 16.2363971,5.95110191 L10.5217925,11.6646669 Z M10.5217925,19.665158 C10.075339,20.111614 9.35387019,20.111614 8.90741671,19.665158 L4.33473297,15.0934488 C3.88842234,14.6469928 3.88842234,13.92552 4.33473297,13.479064 C4.78111502,13.032608 5.50472683,13.032608 5.95118031,13.479064 L9.68245996,17.2400092 L18.0507841,8.9073548 C18.4972376,8.46089883 19.2187064,8.46089883 19.6651599,8.9073548 C20.1116134,9.35381078 20.1116134,10.0752836 19.6651599,10.5217396 L10.5217925,19.665158 Z",
    id: "Shape",
    fill: "#05315F",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCardActivate);
export default __webpack_public_path__ + "static/media/ic_cardActivate.2f67b3a32beee7cb31f34d2058ab8805.svg";
export { ForwardRef as ReactComponent };